// Pull-to-refresh (roadmap #22): pull down at the very top of a screen to sync
// now and redraw. A small pill under the top bar shows "Pull to refresh" →
// "Release to refresh" → "Refreshing…". Ignored inside inputs, open modals, a
// bulk selection and while dragging, so it never fights other gestures.

const THRESHOLD = 70;

export function installPullToRefresh(onRefresh) {
	if (typeof window === "undefined" || window.__pullRefresh) return;
	window.__pullRefresh = true;
	let startY = null;
	let dist = 0;
	let busy = false;
	const pill = document.createElement("div");
	pill.className = "pull-refresh";
	pill.hidden = true;
	document.body.append(pill);

	const blocked = (target) =>
		busy ||
		window.scrollY > 0 ||
		target.closest?.(".ns-page")?.scrollTop > 0 ||
		document.querySelector(".modal-overlay") ||
		document.body.classList.contains("dragging-rows") ||
		document.querySelector('[data-selecting="1"]') ||
		target.closest?.("input, textarea, select, .notif-panel, .drawer");

	window.addEventListener("touchstart", (e) => {
		if (e.touches.length !== 1 || blocked(e.target)) {
			startY = null;
			return;
		}
		startY = e.touches[0].clientY;
		dist = 0;
	}, { passive: true });

	window.addEventListener("touchmove", (e) => {
		if (startY == null) return;
		dist = e.touches[0].clientY - startY;
		if (dist <= 10 || window.scrollY > 0) {
			pill.hidden = true;
			return;
		}
		pill.hidden = false;
		pill.textContent = dist > THRESHOLD ? "Release to refresh" : "Pull to refresh";
		pill.style.transform = `translate(-50%, ${Math.min(dist, THRESHOLD * 1.4) / 2}px)`;
	}, { passive: true });

	window.addEventListener("touchend", async () => {
		if (startY == null) return;
		startY = null;
		if (dist <= THRESHOLD) {
			pill.hidden = true;
			return;
		}
		busy = true;
		pill.textContent = "Refreshing…";
		try {
			await onRefresh();
		} catch (err) {
			console.warn("Pull-to-refresh failed:", err);
		} finally {
			busy = false;
			pill.hidden = true;
			pill.style.transform = "";
		}
	});
}
